// Anita Week 10 / Day 2 — Light of Safety: Stop, Check and Help.
// Verbatim from FINAL Week 10 Part A (Final Quest) source-of-truth package.
// Staged on disk; Week 10 remains a locked placeholder until Days 4–5 are
// authored. Night Runner gate is NOT changed yet.

const day2 = {
  id: 'day-2',
  studentId: 'anita',
  weekId: 'week-10',
  dayId: 'day-2',
  status: 'active',
  title: 'Огонёк безопасности: стоп, проверка и помощь / Light of Safety: Stop, Check and Help',
  shortTitle: 'Огонёк безопасности / Light of Safety',
  theme: 'Анита повторяет круг безопасности, правило проверки с родителем, план «если потерялась» и план против буллинга. / Anita reviews safety circle, check-first rule, lost plan and bullying plan.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'quest-review', 'safety', 'memory-cards', 'creative', 'speech'],
  questMeta: { lightId: 'safety-light', lightNameRu: 'Огонёк безопасности', lightNameEn: 'Light of Safety', questNode: 2, passportStamp: 'безопасность' },
  nimnyIntro:
    'Нимни открывает вторую дверь квеста. За ней светится Огонёк безопасности. Чтобы получить его, Анита вспоминает сильные правила: проверить с родителем, не уходить без разрешения, попросить помощь на месте, сказать «стоп», уйти и рассказать взрослому. / Nimny opens the second quest door. Behind it shines the Light of Safety. To collect it, Anita reviews strong rules: check with parent, do not leave without permission, ask for help in place, say "stop," move away and tell an adult.',
  goals: [
    'Повторить круг безопасности. / Review the safety circle.',
    'Повторить правило «сначала проверить с родителем». / Review check-first rule.',
    'Повторить план «если потерялась». / Review lost plan.',
    'Повторить план против буллинга. / Review bullying plan.',
    'Решать задачи на карточки безопасности, маршруты и время ожидания. / Solve safety cards, route and waiting-time tasks.',
    'Поставить штамп Огонька безопасности. / Add the Light of Safety stamp.'
  ],
  vocabulary: [
    { term: 'безопасность / safety', definition: 'когда человеку не опасно и он знает план. / when a person is not in danger and knows a plan.' },
    { term: 'проверить / check', definition: 'спросить родителя или безопасного взрослого. / ask a parent or safe adult.' },
    { term: 'помощь / help', definition: 'действие, которое помогает. / an action that helps.' },
    { term: 'родитель / parent', definition: 'мама, папа или guardian. / mom, dad or guardian.' },
    { term: 'стоп / stop', definition: 'сильное слово для неприятной ситуации. / a strong word for an unpleasant situation.' },
    { term: 'уйти / move away', definition: 'отойти в безопасное место. / step away to a safe place.' },
    { term: 'рассказать / tell', definition: 'сказать доверенному взрослому. / tell a trusted adult.' },
    { term: 'потерялась / got lost', definition: 'не вижу своего взрослого. / I cannot see my adult.' },
    { term: 'буллинг / bullying', definition: 'когда обида повторяется или есть давление. / when an offence repeats or there is pressure.' },
    { term: 'план / plan', definition: 'шаги, что делать. / steps of what to do.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова огонька безопасности / Safety Light Words',
      prompt: 'Прочитай по-русски:\n\nбезопасность\nпроверить\nпомощь\nродитель\nстоп\nуйти\nрассказать\nпотерялась\nбуллинг\nплан',
      ruPrimaryText: 'Прочитай 10 русских слов безопасности.',
      enHelpText: 'Read the Russian safety words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Фразы безопасности / Safety Sentences',
      prompt: 'Прочитай по-русски:\n\nЯ сначала проверяю с родителем.\nЯ не ухожу без разрешения.\nЕсли я потерялась, я останавливаюсь.\nЯ говорю «стоп», ухожу и рассказываю взрослому.',
      ruPrimaryText: 'Прочитай 4 короткие фразы безопасности.',
      enHelpText: 'I check with my parent first. I do not leave without permission. If I get lost, I stop. I say "stop," move away and tell an adult.',
      answer: 'Attempted Russian reading.' },
    { id: 'safety-memory-sort', type: 'classify', title: 'Задание 3 — Карточки безопасности / Safety Memory Cards',
      prompt: 'Разложи карточки по категориям.\n\nКатегории:\nПроверить с родителем\nПомощь на месте\nСтоп — уйти — рассказать\nНельзя / опасно\n\nКарточки:\n1. Взрослый зовёт к машине за подарком.\n2. Кассир помогает позвать родителя.\n3. Родитель друга говорит: «Пойдём, твоя мама знает.»\n4. Учитель помогает в школе.\n5. Старший ребёнок говорит: «Не рассказывай взрослым.»\n6. Я потерялась в магазине.\n7. Ребёнок каждый день обзывает.\n8. Взрослый просит помочь найти щенка.\n9. Работник места говорит ждать рядом, пока позовёт родителя.\n10. Кто-то толкает возле лестницы.\n11. Я не уверена, можно ли идти.\n12. Кто-то сказал неприятное один раз.',
      ruPrimaryText: 'Разложи 12 карточек: проверить / помощь / стоп-уйти-рассказать / нельзя.',
      enHelpText: 'Sort 12 cards: check / help in place / stop-move-tell / not allowed.',
      categories: [
        { id: 'check', label: 'Проверить с родителем / Check with parent' },
        { id: 'help', label: 'Помощь на месте / Help in place' },
        { id: 'stop', label: 'Стоп — уйти — рассказать / Stop — move — tell' },
        { id: 'forbidden', label: 'Нельзя / опасно / Not allowed' }
      ],
      items: [
        { id: 's1', label: '1. Взрослый зовёт к машине за подарком.', category: 'forbidden' },
        { id: 's2', label: '2. Кассир помогает позвать родителя.', category: 'help' },
        { id: 's3', label: '3. Родитель друга говорит: «Пойдём, твоя мама знает.»', category: 'check' },
        { id: 's4', label: '4. Учитель помогает в школе.', category: 'help' },
        { id: 's5', label: '5. Старший ребёнок говорит: «Не рассказывай взрослым.»', category: 'stop' },
        { id: 's6', label: '6. Я потерялась в магазине.', category: 'help' },
        { id: 's7', label: '7. Ребёнок каждый день обзывает.', category: 'stop' },
        { id: 's8', label: '8. Взрослый просит помочь найти щенка.', category: 'forbidden' },
        { id: 's9', label: '9. Работник места говорит ждать рядом, пока позовёт родителя.', category: 'help' },
        { id: 's10', label: '10. Кто-то толкает возле лестницы.', category: 'forbidden' },
        { id: 's11', label: '11. Я не уверена, можно ли идти.', category: 'check' },
        { id: 's12', label: '12. Кто-то сказал неприятное один раз.', category: 'stop' }
      ],
      answer: 'Проверить с родителем: 3, 11. Помощь на месте: 2, 4, 6, 9. Стоп — уйти — рассказать: 5, 7, 12. Нельзя / опасно: 1, 8, 10.' },
    { id: 'lost-plan-order', type: 'text', title: 'Задание 4 — План «если потерялась» / Lost Plan Order',
      prompt: 'Поставь шаги в правильном порядке:\n\nA. Сказать: «Я потерялась. Помогите найти моего родителя.»\nB. Остановиться.\nC. Ждать в безопасном месте.\nD. Найти работника места, кассу или охрану.\nE. Не уходить далеко искать родителей.',
      ruPrimaryText: 'Поставь 5 шагов lost plan в правильном порядке.',
      enHelpText: 'Order the 5 lost-plan steps correctly.',
      answer: 'B → E → D → A → C.' },
    { id: 'math-safety-cards', type: 'text', title: 'Задание 5 — Считаем карточки безопасности / Count Safety Cards',
      prompt: 'В квесте 24 карточки безопасности.\n\n8 карточек — помощь на месте.\n6 карточек — проверить с родителем.\n5 карточек — стоп, уйти, рассказать.\nОстальные — нельзя / опасно.\n\nОтветь:\n1. Сколько карточек уже известно?\n2. Сколько карточек «нельзя / опасно»?\n3. Сколько карточек требуют взрослого: помощь на месте + проверить с родителем?\n4. Если 24 карточки разделить на 4 группы поровну, сколько в каждой группе?',
      ruPrimaryText: 'Реши 4 задачи про 24 карточки безопасности.',
      enHelpText: 'Solve 4 safety-card count problems.',
      answer: '1) 8 + 6 + 5 = 19. 2) 24 − 19 = 5. 3) 8 + 6 = 14. 4) 24 ÷ 4 = 6.' },
    { id: 'math-help-route', type: 'text', title: 'Задание 6 — Маршрут к помощи / Route to Help',
      prompt: 'На выдуманной карте Нимни путь к стойке помощи:\n\n3 шага восток\n4 шага север\n2 шага запад\n1 шаг север\n\nОтветь:\n1. Сколько всего шагов?\n2. Сколько вертикальных шагов? север + север.\n3. Сколько горизонтальных шагов? восток + запад.\n4. Если каждый шаг занимает 2 минуты, сколько минут весь путь?',
      ruPrimaryText: 'Реши 4 задачи про маршрут к стойке помощи.',
      enHelpText: 'Solve 4 help-route problems.',
      answer: '1) 3 + 4 + 2 + 1 = 10. 2) 4 + 1 = 5. 3) 3 + 2 = 5. 4) 10 × 2 = 20 минут.' },
    { id: 'math-waiting-time', type: 'text', title: 'Задание 7 — Время ожидания / Waiting Time',
      prompt: 'Анита ждёт в безопасном месте:\n\nсначала 5 минут,\nпотом ещё 5 минут,\nпотом ещё 10 минут.\n\nОтветь:\n1. Сколько всего минут?\n2. Если ждать нужно 30 минут, сколько минут осталось после 20 минут?\n3. Если 30 минут разделить на 3 равные части, сколько минут в каждой?',
      ruPrimaryText: 'Реши 3 задачи про время ожидания.',
      enHelpText: 'Solve 3 waiting-time problems.',
      answer: '1) 5 + 5 + 10 = 20. 2) 30 − 20 = 10. 3) 30 ÷ 3 = 10.' },
    { id: 'spelling-safety-light', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\n\nстоп\nпомощь\nждать\nплан\nучитель\n\nВставь буквы:\n\nст_п\nпомо_ь\nжда_ь\nпл_н\nучи_ель',
      ruPrimaryText: 'Напиши 5 слов и вставь пропущенные буквы.',
      enHelpText: 'Write 5 words and fill in the missing letters.',
      answer: 'стоп, помощь, ждать, план, учитель.' },
    { id: 'creative-safety-stamp', type: 'text', title: 'Задание 9 — Штамп огонька безопасности / Safety Light Stamp',
      prompt: 'Нарисуй штамп Огонька безопасности.\n\nВ штампе должны быть:\n1. огонёк\n2. знак «стоп»\n3. безопасный взрослый как роль, не имя\n4. фраза:\n\nЯ знаю план безопасности.',
      ruPrimaryText: 'Нарисуй штамп Огонька безопасности с 4 элементами.',
      enHelpText: 'Draw the Light of Safety stamp with 4 elements.',
      answer: 'Open-ended. Accept if stamp includes light, stop sign, safe adult role and phrase.' },
    { id: 'speech-safety-light', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\n\nЯ сначала проверяю с родителем.\nЕсли я потерялась, я останавливаюсь.\nЕсли буллинг, я говорю «стоп», ухожу и рассказываю взрослому.',
      ruPrimaryText: 'Скажи родителю 3 safety фразы по-русски.',
      enHelpText: 'Say 3 safety phrases to parent in Russian.',
      answer: 'Accept if Anita says the safety plan with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова безопасности.',
    '2. Прочитай 4 фразы.',
    '3. Разложи карточки безопасности.',
    '4. Поставь шаги lost plan в порядок.',
    '5. Реши 3 math-задачи.',
    '6. Нарисуй штамп Огонька безопасности.',
    '7. Скажи родителю план безопасности.'
  ],
  printWorksheet: {
    title: 'Огонёк безопасности: стоп, проверка и помощь / Light of Safety',
    subtitle: 'Неделя 10 · День 2 / Week 10 · Day 2 · Quest Passport',
    pages: [
      { title: 'Quest Passport: Огонёк безопасности / Light of Safety',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Нимни открывает вторую дверь финального квеста. Собери Огонёк безопасности.' },
          { type: 'text', text: 'Задание 1 — Слова огонька безопасности. Прочитай и обведи:' },
          { type: 'list', items: [
            'безопасность / safety',
            'проверить / check',
            'помощь / help',
            'родитель / parent',
            'стоп / stop',
            'уйти / move away',
            'рассказать / tell',
            'потерялась / got lost',
            'буллинг / bullying',
            'план / plan'
          ] },
          { type: 'text', text: 'Задание 2 — Фразы безопасности. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я сначала проверяю с родителем.',
            '□ Я не ухожу без разрешения.',
            '□ Если я потерялась, я останавливаюсь.',
            '□ Я говорю «стоп», ухожу и рассказываю взрослому.'
          ] }
        ] },
      { title: 'Карточки, план и математика / Cards, Plan and Math',
        blocks: [
          { type: 'text', text: 'Задание 3 — Карточки безопасности. Категории: П = проверить с родителем, М = помощь на месте, С = стоп — уйти — рассказать, Н = нельзя / опасно.' },
          { type: 'list', items: [
            '1. Взрослый зовёт к машине за подарком. ____',
            '2. Кассир помогает позвать родителя. ____',
            '3. Родитель друга говорит: «Пойдём, твоя мама знает.» ____',
            '4. Учитель помогает в школе. ____',
            '5. Старший ребёнок говорит: «Не рассказывай взрослым.» ____',
            '6. Я потерялась в магазине. ____',
            '7. Ребёнок каждый день обзывает. ____',
            '8. Взрослый просит помочь найти щенка. ____',
            '9. Работник места говорит ждать рядом, пока позовёт родителя. ____',
            '10. Кто-то толкает возле лестницы. ____',
            '11. Я не уверена, можно ли идти. ____',
            '12. Кто-то сказал неприятное один раз. ____'
          ] },
          { type: 'text', text: 'Задание 4 — План «если потерялась». Поставь шаги в порядке:' },
          { type: 'list', items: [
            'A. Сказать фразу помощи.',
            'B. Остановиться.',
            'C. Ждать в безопасном месте.',
            'D. Найти работника места, кассу или охрану.',
            'E. Не уходить далеко искать родителей.'
          ] },
          { type: 'text', text: 'Правильный порядок: ____ → ____ → ____ → ____ → ____' },
          { type: 'text', text: 'Задание 5 — Считаем карточки безопасности:' },
          { type: 'list', items: [
            '8 + 6 + 5 = ______',
            '24 − ______ = ______',
            '8 + 6 = ______',
            '24 ÷ 4 = ______'
          ] }
        ] },
      { title: 'Маршрут, время и штамп / Route, Time and Stamp',
        blocks: [
          { type: 'text', text: 'Задание 6 — Маршрут к помощи:' },
          { type: 'list', items: [
            '3 восток + 4 север + 2 запад + 1 север = ______ шагов',
            'Вертикальные шаги: 4 + 1 = ______',
            'Горизонтальные шаги: 3 + 2 = ______',
            '10 шагов × 2 минуты = ______ минут'
          ] },
          { type: 'text', text: 'Задание 7 — Время ожидания:' },
          { type: 'list', items: [
            '5 + 5 + 10 = ______ минут',
            '30 − 20 = ______ минут осталось',
            '30 ÷ 3 = ______ минут'
          ] },
          { type: 'text', text: 'Задание 8 — Правописание. Напиши и вставь буквы:' },
          { type: 'list', items: ['стоп   помощь   ждать   план   учитель', 'ст_п   помо_ь   жда_ь   пл_н   учи_ель'] },
          { type: 'text', text: 'Задание 9 — Штамп огонька безопасности. Нарисуй:' },
          { type: 'list', items: [
            '□ огонёк',
            '□ знак «стоп»',
            '□ безопасный взрослый как роль, не имя',
            '□ фраза «Я знаю план безопасности.»'
          ] },
          { type: 'text', text: 'Задание 10 — Объясни родителю. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я сначала проверяю с родителем.',
            '□ Если я потерялась, я останавливаюсь.',
            '□ Если буллинг, я говорю «стоп», ухожу и рассказываю взрослому.'
          ] },
          { type: 'text', text: 'Parent Check: □ Прочитала слова  □ Прочитала фразы  □ Разложила карточки  □ Поставила lost plan в порядок  □ Решила math-задачи  □ Сделала штамп  □ Объяснила родителю.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита собирает Огонёк безопасности и повторяет Week 2: check first, lost plan, bullying plan.',
    mathGoal: 'Сложение, вычитание, умножение, деление, маршрут по шагам и время ожидания.',
    russianGoal: 'Прочитать слова безопасность, проверить, помощь, родитель, стоп, уйти, рассказать, потерялась, буллинг, план.',
    readingWritingGoal: 'Прочитать 4 фразы, написать 5 слов, подписать safety stamp.',
    practicalGoal: 'Повторить safety actions: check parent, ask help in place, stop/move/tell.',
    parentTheoryCard: {
      title: 'Как повторять безопасность без тревоги',
      purpose: 'Помочь родителю повторить правила безопасности спокойно и уверенно.',
      keyMessage: 'Безопасность — это не страх. Это знание плана.',
      parentScript: [
        '«Сегодня мы повторяем не страшилки, а план.»',
        '«Ты знаешь, что делать: проверить, попросить помощь, сказать стоп, рассказать взрослому.»',
        '«Если ситуация реальная и тревожная, ты всегда можешь сказать мне.»'
      ],
      practiceSteps: [
        'Прочитать фразы.',
        'Разложить карточки.',
        'Потренировать lost plan.',
        'Сказать три сильные фразы.'
      ],
      doNotSay: [
        'Не пугать ребёнка.',
        'Не говорить «все опасны».',
        'Не просить реальные адреса или имена онлайн.'
      ],
      paperOnlyNotes: [
        'Реальные семейные правила обсуждать только устно или на бумаге дома.',
        'В онлайн-уроке использовать роли, не имена.'
      ]
    },
    whatThisLessonTeaches: 'Анита повторяет правила безопасности как спокойный план действий.',
    keyMessage: 'Я знаю план: проверить, не уходить, попросить помощь, сказать стоп, рассказать взрослому.',
    howToExplain: 'Скажите: «Безопасность — это когда у тебя есть план. Ты не обязана решать всё одна.»',
    exampleDialogue:
      'Parent: Что ты делаешь, если потерялась?\nChild: Останавливаюсь и прошу помощи у работника места.\nParent: Что если буллинг?\nChild: Стоп, ухожу, рассказываю взрослому.',
    readingSupport: 'Слова «потерялась», «рассказать», «безопасность» читать по частям.',
    russianSpeechGoal: 'Анита говорит минимум 2 safety rules по-русски.',
    mathAnswerKey:
      'safety-memory-sort: Проверить с родителем: 3, 11. Помощь на месте: 2, 4, 6, 9. Стоп — уйти — рассказать: 5, 7, 12. Нельзя / опасно: 1, 8, 10.\nlost-plan-order: B → E → D → A → C.\nmath-safety-cards: 1) 19. 2) 5. 3) 14. 4) 6.\nmath-help-route: 1) 10. 2) 5. 3) 5. 4) 20.\nmath-waiting-time: 1) 20. 2) 10. 3) 10.',
    spellingAnswerKey: 'стоп\nпомощь\nждать\nплан\nучитель',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения.' },
      { taskId: 'safety-memory-sort', answer: 'Проверить: 3,11; Помощь: 2,4,6,9; Стоп: 5,7,12; Нельзя: 1,8,10.' },
      { taskId: 'lost-plan-order', answer: 'B, E, D, A, C.' },
      { taskId: 'math-safety-cards', answer: '19; 5; 14; 6.' },
      { taskId: 'math-help-route', answer: '10; 5; 5; 20.' },
      { taskId: 'math-waiting-time', answer: '20; 10; 10.' },
      { taskId: 'spelling-safety-light', answer: 'стоп, помощь, ждать, план, учитель.' },
      { taskId: 'creative-safety-stamp', answer: 'stamp with safety items and phrase.' },
      { taskId: 'speech-safety-light', answer: 'safety explanation attempted.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита разложила карточки.',
      'Анита повторила lost plan.',
      'Анита решила math tasks.',
      'Анита сделала safety stamp.',
      'Анита объяснила план.'
    ],
    spellingCheck: 'Проверить стоп, помощь, ждать, план, учитель.',
    readingCheck: 'Засчитывать попытку русского чтения.',
    practicalCheck: 'Анита должна помнить: не уходить, проверять, просить помощь на месте, рассказывать взрослому.',
    drawingCriteria: 'Штамп содержит огонёк, stop sign, роль безопасного взрослого и фразу.',
    commonMistakes: [
      '«Я сама побегу искать.» Правильно: «Остановиться и попросить помощь на месте.»',
      '«Рассказать взрослому — плохо.» Правильно: «Рассказать — это получить помощь.»',
      '«Если знакомый, можно идти.» Правильно: «Сначала проверить с родителем.»'
    ],
    discussionPrompts: [
      'Какую фразу легче сказать?',
      'Что делать, если потерялась?',
      'Почему не надо хранить опасные секреты?'
    ],
    ifEasy: 'Попросить Аниту придумать свою safety card.',
    ifDifficult: 'Оставить только 6 карточек.',
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за уверенную фразу или аккуратный штамп.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не вводить реальные имена, школу, адрес, телефон или маршруты.',
    safetyNotes: 'Если ребёнок рассказывает о реальной тревожной ситуации, спокойно выслушать и при необходимости обратиться к соответствующему взрослому.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'confident-phrase', label: 'Бонус за уверенную safety-фразу', amount: 1 },
      { id: 'neat-safety-stamp', label: 'Бонус за аккуратный штамп безопасности', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'safety-memory-sort', 'lost-plan-order', 'math-safety-cards', 'math-help-route', 'math-waiting-time', 'spelling-safety-light', 'creative-safety-stamp', 'speech-safety-light'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-10-day-3'
};

export default day2;
